import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-type-replenishment",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListTypeReplenishmentComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Replenishment orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {order_type: "replenishment"}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-type-replenishment",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
